import { InjectionToken } from '@angular/core';
export const AUTH_API = new InjectionToken<string>('authApi');
export const AUTH_USE_PRODUCT_LOGIN = new InjectionToken<string>('authUseProductLogin');
export const AUTH_MAIN_ACCOUNT_ID = new InjectionToken<string>('authMainAccountId');
